/** @jsxImportSource @emotion/react */
import { useTranslation } from "react-i18next";

import { css } from "@emotion/react";

import Typography from "@mui/material/Typography";

import { NewsDto } from "../../..";
import Badge from "../../../../../../../components/Badge/Badge";
import { useStyles } from "../../../../../../../components/NotesAccordion/styles";
import { useDateTime } from "../../../../../../../shared";

interface ReleaseNotesTitleProps {
  note: NewsDto;
  index: number;
}

const ReleaseNotesTitle = ({ note, index }: ReleaseNotesTitleProps) => {
  const { formatDateIntoMonthYearString } = useDateTime();
  const { t } = useTranslation();
  const { titleRowCSS, titleBadgeCSS } = useStyles();

  const badgeText = note.draft
    ? t("News##unpublished")
    : t("General##latest version");

  const badgeColor = note.draft ? "warning" : "success";

  return (
    <div css={css(titleRowCSS)}>
      <Typography variant="body1Medium">
        {formatDateIntoMonthYearString(note.createdAt)}
      </Typography>
      <div css={css(titleBadgeCSS)}>
        {index === 0 && <Badge color={badgeColor}>{badgeText}</Badge>}
      </div>
    </div>
  );
};

export default ReleaseNotesTitle;
